{
    "IncludeendedonholdLabel": "Gesprekken die in de wacht staan worden afgebroken",
    "UnreturnedCalls_SectionHeader": "Niet beantwoorde oproepen",
    "UnreturnedCalls_SectionPara": "Je kunt kiezen of bepaalde soorten gesprekken als achtergelaten worden beschouwd in de rapporten \"Onbeantwoorde verloren gesprekken\" en in de statistiek \"Onbeantwoorde gesprekken\".",
    "NAME": "UnreturnedCalls",
    "IncludeescapedLabel": "Oproepen beëindigd door Escape worden verlaten"
}